import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import {
	OVERSIZE_GLASS_MESSAGE,
	getDefaultPerspexGlassId,
	getOversizePerspexGlassOptions,
} from '../../Helpers/Helpers';

export default class OversizeGlassModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			modalSelectedGlassId: null,
		};
		this.handleGlassChange = this.handleGlassChange.bind(this);
		this.handleConfirm = this.handleConfirm.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (this.props.show && !prevProps.show) {
			const options = getOversizePerspexGlassOptions(this.props.glasses);
			const defaultId = getDefaultPerspexGlassId(this.props.glasses);
			const initialId = defaultId || (options.length > 0 ? options[0].id : null);
			this.setState({ modalSelectedGlassId: initialId });
		}
	}

	handleGlassChange(e) {
		this.setState({ modalSelectedGlassId: parseFloat(e.target.value) });
	}

	handleConfirm() {
		const { modalSelectedGlassId } = this.state;
		if (modalSelectedGlassId && this.props.onConfirm) {
			this.props.onConfirm(modalSelectedGlassId);
		}
	}

	render() {
		const { show, onHide } = this.props;
		const options = getOversizePerspexGlassOptions(this.props.glasses);
		const { modalSelectedGlassId } = this.state;
		const selectedId =
			modalSelectedGlassId != null
				? modalSelectedGlassId
				: options.length > 0
					? options[0].id
					: null;

		return (
			<Modal show={show} onHide={onHide}>
				<Modal.Header closeButton>
					<Modal.Title id="contained-modal-title-lg">Change Required</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>{OVERSIZE_GLASS_MESSAGE}</p>
					{options.length > 0 ? (
						<div className="oversize-glass-options">
							<p className="oversize-glass-options-title"><strong>Please select a glass option:</strong></p>
							{options.map((opt) => (
								<div className="oversize-glass-option" key={opt.id}>
									<label className="checkcontainer">
										<input
											type="radio"
											name="oversizeGlass"
											value={opt.id}
											checked={parseFloat(selectedId) === parseFloat(opt.id)}
											onChange={this.handleGlassChange}
										/>
										{opt.title}
										<span className="radiobtn"></span>
									</label>
								</div>
							))}
						</div>
					) : (
						<p className="text-danger m-t-10">Perspex glass options are not available. Please try again later.</p>
					)}
				</Modal.Body>
				<Modal.Footer>
					<Button className="btn btn-primary btn-danger" onClick={onHide}>Cancel</Button>
					<Button
						className="btn btn-primary btn-default"
						onClick={this.handleConfirm}
						disabled={!selectedId || options.length === 0}
					>
						That's OK
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}
